import axios from "axios";
import alert from "@/lang/AlertMessages.js";
// import label from "@/lang/StaticLabels.js";

export default {
  getConfig({ dispatch, commit }) {
    axios
      .get("client/Config?languageId=1")
      .then((res) => {
        commit("setConfig", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getPoster({ dispatch, commit }) {
    axios
      .get("Client/Poster/GetByPosition/1")
      .then((res) => {
        commit("setPoster", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getContactUs({ dispatch, commit }) {
    axios
      .get("client/Page?name=ContactUs")
      .then((res) => {
        commit("setContactUs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getAboutUs({ dispatch, commit }) {
    axios
      .get("client/Page?name=aboutUs")
      .then((res) => {
        commit("setAboutUs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getSocialNetwork({ dispatch, commit }) {
    axios
      .get("client/SocialNetwork")
      .then((res) => {
        commit("setSocialNetwork", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getMenu({ dispatch, commit }) {
    axios
      .get("Client/Menu")
      .then((res) => {
        commit("setMenu", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // slides Actions -------------------------------------------------------------------------------
  getSlides({ dispatch, commit }) {
    axios
      .get("client/Slider")
      .then((res) => {
        commit("setSlides", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // Services Actions -------------------------------------------------------------------------------
  getServices({ dispatch, commit }, data) {
    axios
      .get("Client/Services?pageSize=" + data)
      .then((res) => {
        commit("setServices", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getServicesById({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get("Client/Services/" + data)
      .then((res) => {
        commit("setServicesById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },

  // Support Actions --------------------------------------------
  getSupport({ dispatch, commit }) {
    axios
      .get("Client/Support/1")
      .then((res) => {
        commit("setSupport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Tutorials Actions -------------------------------------------------------------------------------
  getTutorials({ dispatch, commit }) {
    axios
      .get("client/Tutorial")
      .then((res) => {
        commit("setTutorials", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getTutorialsPage({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get(
        "client/Tutorial?pageSize=" +
          data.pageSize +
          "&pageNumber=" +
          data.pageNumber +
          "&categoryId=" +
          data.categoryId +
          "&tagId=" +
          data.tagId +
          "&title=" +
          data.title +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setTutorialsPage", res.data.data);
        commit("setTutorialsPageTotal", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  getTutorialById({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get("client/Tutorial/" + data)
      .then((res) => {
        commit("setTutorial", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  getRelatedTutorials({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get("client/Tutorial?pageSize=5&pageNumber=1&categoryId=" + data)
      .then((res) => {
        commit("setRelatedTutorials", res.data.data);
        // commit("setTutorialsPageTotal", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  // Categories Actions -------------------------------------------------------------------------------
  getCategories({ dispatch, commit }, data) {
    axios
      .get("client/Category/GetTreeJson?groupId=" + data)
      .then((res) => {
        commit("setCategories", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getCategory({ dispatch, commit }, data) {
    axios
      .get("client/Category?groupId=" + data)
      .then((res) => {
        commit("setCategory", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // Gallery Actions -------------------------------------------------------------------------------

  getImages({ dispatch, commit }) {
    axios
      .get("client/ImageGallery")
      .then((res) => {
        commit("setGalleries", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getImagesPage({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get(
        "client/ImageGallery?pageSize=" +
          data.pageSize +
          "&pageNumber=" +
          data.pageNumber +
          "&categoryId=" +
          data.categoryId +
          "&tagId=" +
          data.tagId +
          "&title=" +
          data.title +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setGalleryPage", res.data.data);
        commit("setGalleryPageTotal", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  getImageById({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get("client/ImageGallery/" + data)
      .then((res) => {
        commit("setGallery", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  getVideos({ dispatch, commit }) {
    axios
      .get("client/MovieGallery")
      .then((res) => {
        commit("setGalleries", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getVideosPage({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get(
        "client/MovieGallery?pageSize=" +
          data.pageSize +
          "&pageNumber=" +
          data.pageNumber +
          "&categoryId=" +
          data.categoryId +
          "&tagId=" +
          data.tagId +
          "&title=" +
          data.title +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setGalleryPage", res.data.data);
        commit("setGalleryPageTotal", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  getVideoById({ dispatch, commit }, data) {
    axios
      .get("client/MovieGallery/" + data)
      .then((res) => {
        commit("setGallery", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getGalleryListById({ dispatch, commit }, data) {
    axios
      .get("client/GalleryAlbum/" + data)
      .then((res) => {
        commit("setGalleryList", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getSounds({ dispatch, commit }) {
    axios
      .get("client/SoundGallery")
      .then((res) => {
        commit("setGalleries", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getSoundsPage({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get(
        "client/SoundGallery?pageSize=" +
          data.pageSize +
          "&pageNumber=" +
          data.pageNumber +
          "&categoryId=" +
          data.categoryId +
          "&tagId=" +
          data.tagId +
          "&title=" +
          data.title +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setGalleryPage", res.data.data);
        commit("setGalleryPageTotal", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  getSoundById({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get("client/SoundGallery/" + data)
      .then((res) => {
        commit("setGallery", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },

  // Products Actions -------------------------------------------------------------------------------
  getProducts({ dispatch, commit }) {
    axios
      .get("client/Product")
      .then((res) => {
        commit("setProducts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getProductsHome({ dispatch, commit }) {
    axios
      .get("client/Widget/1")
      .then((res) => {
        commit("setProductsHome", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getProductsPage({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get(
        "client/Product?pageSize=" +
          data.pageSize +
          "&pageNumber=" +
          data.pageNumber +
          "&categoryId=" +
          data.categoryId +
          "&tagId=" +
          data.tagId +
          "&title=" +
          data.title +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setProductsPage", res.data.data);
        commit("setProductsPageTotal", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  getProductById({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get("client/Product/" + data)
      .then((res) => {
        commit("setProduct", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  getRelatedProducts({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get("client/Product?pageSize=5&pageNumber=1&categoryId=" + data)
      .then((res) => {
        commit("setRelatedProducts", res.data.data);
        // commit("setTutorialsPageTotal", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  // Blogs Actions -------------------------------------------------------------------------------
  getBlogs({ dispatch, commit }) {
    commit("setLoading", 1, { root: true });
    axios
      .get("client/Blog")
      .then((res) => {
        commit("setBlogs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  getRelatedBlogs({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get("client/Blog?categoryId=" + data)
      .then((res) => {
        commit("setRelatedBlogs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  getBlogHome({ dispatch, commit }) {
    axios
      .get("client/Widget/1")
      .then((res) => {
        commit("setBlogHome", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getBlogsPage({ dispatch, commit }, data) {
    commit("setLoading", 1, { root: true });
    axios
      .get(
        "client/Blog?pageSize=" +
          data.pageSize +
          "&pageNumber=" +
          data.pageNumber +
          "&categoryId=" +
          data.categoryId +
          "&tagId=" +
          data.tagId +
          "&title=" +
          data.title +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setBlogsPage", res.data.data);
        commit("setBlogsPageTotal", res.data.total);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  getBlogById({ dispatch, commit }, data) {
    axios
      .get("client/Blog/" + data)
      .then((res) => {
        commit("setBlog", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // ContactMessages Actions -----------------------------
  sendMessage({ dispatch, commit }, data) {
    axios
      .post("Client/ContactUs", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  // Comments Actions -------------------------------------------------------------------------------
  getBlogComments({ dispatch, commit }, data) {
    axios
      .get(
        "client/Comment/GetPostCommentTreeJson?&entityId=" +
          data.entityId +
          "&pageNumber=" +
          data.pageNumber +
          "&pageSize=" +
          data.pageSize +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setComments", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  sendCommentBlogs({ dispatch, commit }, data) {
    axios
      .post("client/Blog", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },

  getProductComments({ dispatch, commit }, data) {
    axios
      .get(
        "client/Comment/GetProductCommentTreeJson?&entityId=" +
          data.entityId +
          "&pageNumber=" +
          data.pageNumber +
          "&pageSize=" +
          data.pageSize +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setComments", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  sendCommentProducts({ dispatch, commit }, data) {
    axios
      .post("client/Product", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  getTutorialComments({ dispatch, commit }, data) {
    axios
      .get(
        "client/Comment/GetTutorialCommentTreeJson?&entityId=" +
          data.entityId +
          "&pageNumber=" +
          data.pageNumber +
          "&pageSize=" +
          data.pageSize +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setComments", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  sendCommentTutorials({ dispatch, commit }, data) {
    axios
      .post("client/Tutorial", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  getGalleryComments({ dispatch, commit }, data) {
    axios
      .get(
        "client/Comment/GetGalleryCommentTreeJson?&entityId=" +
          data.entityId +
          "&pageNumber=" +
          data.pageNumber +
          "&pageSize=" +
          data.pageSize +
          "&sort=" +
          data.sort
      )
      .then((res) => {
        commit("setComments", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  sendCommentImageGallery({ dispatch, commit }, data) {
    axios
      .post("client/ImageGallery", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  sendCommentSoundGallery({ dispatch, commit }, data) {
    axios
      .post("client/SoundGallery", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  sendCommentVideoGallery({ dispatch, commit }, data) {
    axios
      .post("client/MovieGallery", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.commentSent,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },
  // NewsLetter Actions -------------------------------------------------------------------------------
  sendNewsLetter({ dispatch }, data) {
    axios
      .post("Client/Subscriber", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // Rules Actions .....................................
  getRules({ dispatch, commit }) {
    axios
      .get("client/Page?name=Rules")
      .then((res) => {
        commit("setRules", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // Cooperation Actions -------------------------------------------------------------------------------
  getProvince({ dispatch, commit }) {
    axios
      .get("Client/Province")
      .then((res) => {
        commit("setProvince", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCity({ dispatch, commit }, data) {
    axios
      .get("Client/Province/" + data)
      .then((res) => {
        commit("setCity", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  sendBranch({ dispatch, commit }, data) {
    axios
      .post("Client/Branch", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.send,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false);
      });
  },
  getActivityFields({ dispatch, commit }) {
    commit("setLoading", 1, { root: true });
    axios
      .get("Client/ActivityField")
      .then((res) => {
        commit("setActivityFields", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", 0, { root: true });
        }, 800);
      });
  },
  sendResume({ dispatch, commit }, data) {
    axios
      .post("Client/Resume", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.send,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false);
      });
  },
  // Customer Actions --------------------------------------------
  getCustomerOpinion({ dispatch, commit }) {
    axios
      .get("Client/CustomerOpinion")
      .then((res) => {
        commit("setCustomerOpinion", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCustomerBanners({ dispatch, commit }) {
    axios
      .get("client/Banner/Customer")
      .then((res) => {
        commit("setCustomerBanners", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // -----------------------------------------------------------
  getTeam({ dispatch, commit }) {
    axios
      .get("Client/Team")
      .then((res) => {
        commit("setTeam", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPoolSessions({ dispatch, commit }) {
    axios
      .get("Client/PoolSession")
      .then((res) => {
        commit("setPoolSessions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
};
